export default __webpack_public_path__ + "images/YL.4ec6bcd.png";